import React from "react";
import LeagueCreatedSuccess from "./LeagueCreatedSuccess";

// Route entry for /contest/private-league-created.
//
// The screen itself is shared with the public flow — see LeagueCreatedSuccess.
// The `private` variant supplies the copy and the qushi.io/join/ link prefix.
const PrivateLeagueCreatedSuccess = () => <LeagueCreatedSuccess variant="private" />;

export default PrivateLeagueCreatedSuccess;
